import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles((theme) => ({
  tooltip: {
    width: 194,
    maxWidth: 194,
    minWidth: 194,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  itemText: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
  container: {
    height: 25,
    width: 50,
    display: "flex",
    justifyContent: "center",
  },
}))

/**
 * A help icon that displays a message explaining how to view more info about questionnaire scores when hovered over.
 */
const QuestionnaireScoringHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <Tooltip
        placement="top-end"
        title={
          <>
            <Typography variant="body1" className={classes.title}>
              Questionnaire Scoring
            </Typography>
            <Typography variant="body1" className={classes.itemText}>
              Hover over the score to see the score's category and completion
              date.
            </Typography>
          </>
        }
        className={classes.tooltip}
      >
        <HelpIcon />
      </Tooltip>
    </div>
  )
}

export default QuestionnaireScoringHelpIcon
